export default "__VITE_ASSET__CwddlKPV__"